/* eslint-disable prefer-promise-reject-errors */

const DB_NAME = 'PRODUCTS_STORAGE'
const DB_VERSION = 1
const DB_IMG_NAME = 'IMAGES_STORAGE'
const DB_SUGGESTIONS_NAME = 'SUGGESTIONS_STORAGE'
const DB_VERSION_SUGGESTIONS = 1

export default {
    async addProdSI () {
        this.addDisabled = true
        // random prodSItem for now
        let prodSItem = {
            name: 'ProdSI' + Math.floor(Math.random() * 100),
            age: Math.floor(Math.random() * 10) + 1
        }
        await this.addProdSIToDb(prodSItem)
        this.prodSI = await this.getProdSIsFromDb()
        this.addDisabled = false
    },
    async addProdSIToDb (prodSItem, db) {
        return new Promise((resolve, reject) => {
            let trans = db.transaction(['prodSI'], 'readwrite')
            trans.oncomplete = e => {
                resolve()
            }

            let store = trans.objectStore('prodSI')
            store.add(prodSItem)
        })
    },
    async deleteProdSIFromDb () {
        let db = await this.getDb()
        let prodSI = await this.getProdSIsFromDb(db)
        return new Promise((resolve, reject) => {
            let trans = db.transaction(['prodSI'], 'readwrite')
            trans.oncomplete = e => {
                resolve()
            }
            let store = trans.objectStore('prodSI')
            if (prodSI && prodSI.length > 0) {
                prodSI.forEach(element => {
                    store.delete(element.id)
                })
            }
            resolve()
        })
    },
    async getProdSIsFromDb (db) {
        return new Promise((resolve, reject) => {
            let trans = db.transaction(['prodSI'], 'readonly')
            trans.oncomplete = e => {
                resolve(prodSI)
            }

            let store = trans.objectStore('prodSI')
            let prodSI = []

            store.openCursor().onsuccess = e => {
                let cursor = e.target.result
                if (cursor) {
                    prodSI.push(cursor.value)
                    cursor.continue()
                }
            }
        })
    },
    async getDb () {
        return new Promise((resolve, reject) => {
            let request = window.indexedDB.open(DB_NAME, DB_VERSION)
            request.onerror = e => {
                console.log('Error opening db', e)
                reject('Error')
            }

            request.onsuccess = e => {
                resolve(e.target.result)
            }

            request.onupgradeneeded = e => {
                let db = e.target.result
                db.createObjectStore('prodSI', { autoIncrement: true, keyPath: 'id' })
            }
        })
    },
    async getImageDB () {
        return new Promise((resolve, reject) => {
            let request = window.indexedDB.open(DB_IMG_NAME, DB_VERSION)
            request.onerror = e => {
                console.log('Error opening db', e)
                reject('Error')
            }

            request.onsuccess = e => {
                resolve(e.target.result)
            }

            request.onupgradeneeded = e => {
                let db = e.target.result
                db.createObjectStore('ImagesSI', { autoIncrement: true, keyPath: 'id' })
            }
        })
    },
    async clearDB () {
        // window.indexedDB.deleteDatabase(DB_IMG_NAME)
        // window.indexedDB.deleteDatabase(DB_SUGGESTIONS_NAME)
        window.indexedDB.deleteDatabase(DB_NAME)
    },
    async addImageSI () {
        this.addDisabled = true
        let imageSItem = {
            name: 'ImagesSI' + Math.floor(Math.random() * 100),
            age: Math.floor(Math.random() * 10) + 1
        }
        await this.addImagesSIToDb(imageSItem)
        this.imageSI = await this.getImagesSIsFromDb()
        this.addDisabled = false
    },
    async addImagesSIToDb (imageItem, db) {
        return new Promise((resolve, reject) => {
            let trans = db.transaction(['ImagesSI'], 'readwrite')
            trans.oncomplete = e => {
                resolve()
            }

            let store = trans.objectStore('ImagesSI')
            store.add(imageItem)
        })
    },
    async deleteImagesSIFromDb () {
        let db = await this.getImageDB()
        let imageSI = await this.getImagesSIsFromDb(db)
        return new Promise((resolve, reject) => {
            let trans = db.transaction(['ImagesSI'], 'readwrite')
            trans.oncomplete = e => {
                resolve()
            }
            let store = trans.objectStore('ImagesSI')
            if (imageSI && imageSI.id) {
                store.delete(imageSI.id)
            } else if (imageSI && imageSI.length > 0) {
                imageSI.forEach(element => {
                    store.delete(element.id)
                })
            }
        })
    },
    async getImagesSIsFromDb (db) {
        return new Promise((resolve, reject) => {
            let trans = db.transaction(['ImagesSI'], 'readonly')
            trans.oncomplete = e => {
                resolve(imagesSI)
            }

            let store = trans.objectStore('ImagesSI')
            let imagesSI = {}

            store.openCursor().onsuccess = e => {
                let cursor = e.target.result
                if (cursor) {
                    imagesSI = cursor.value
                    // imagesSI.push(cursor.value)
                    cursor.continue()
                }
            }
        })
    },
    async getSuggestionsDB () {
        return new Promise((resolve, reject) => {
            let request = window.indexedDB.open(DB_SUGGESTIONS_NAME, DB_VERSION_SUGGESTIONS)
            request.onerror = e => {
                console.log('Error opening db', e)
                reject('Error')
            }

            request.onsuccess = e => {
                resolve(e.target.result)
            }

            request.onupgradeneeded = e => {
                let db = e.target.result
                db.createObjectStore('SuggestionsSI', { autoIncrement: true, keyPath: 'id' })
            }
        })
    },
    async addSuggestionSI () {
        this.addDisabled = true
        let suggestionSItem = {
            name: 'SuggestionsSI' + Math.floor(Math.random() * 100),
            age: Math.floor(Math.random() * 10) + 1
        }
        await this.addSuggestionsSIToDb(suggestionSItem)
        this.suggestionSI = await this.getSuggestionsSIsFromDb()
        this.addDisabled = false
    },
    async addSuggestionsSIToDb (suggestionItem, db) {
        db = db || await this.getSuggestionsDB()
        return new Promise((resolve, reject) => {
            let trans = db.transaction(['SuggestionsSI'], 'readwrite')
            trans.oncomplete = e => {
                resolve()
            }

            let store = trans.objectStore('SuggestionsSI')
            store.add(suggestionItem)
        })
    },
    async deleteSuggestionsSIFromDb () {
        let db = await this.getSuggestionsDB()
        let suggestionSI = await this.getSuggestionsSIsFromDb(db)
        return new Promise((resolve, reject) => {
            let trans = db.transaction(['SuggestionsSI'], 'readwrite')
            trans.oncomplete = e => {
                resolve()
            }
            let store = trans.objectStore('SuggestionsSI')
            if (suggestionSI && suggestionSI.id) {
                store.delete(suggestionSI.id)
            } else if (suggestionSI && suggestionSI.length > 0) {
                suggestionSI.forEach(element => {
                    store.delete(element.id)
                })
            }
        })
    },
    async getSuggestionsSIsFromDb (db) {
        db = db || await this.getSuggestionsDB()
        return new Promise((resolve, reject) => {
            let trans = db.transaction(['SuggestionsSI'], 'readonly')
            trans.oncomplete = e => {
                resolve(suggestionsSI)
            }

            let store = trans.objectStore('SuggestionsSI')
            let suggestionsSI = {}

            store.openCursor().onsuccess = e => {
                let cursor = e.target.result
                if (cursor) {
                    suggestionsSI = cursor.value
                    cursor.continue()
                }
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/assets/libs/IndexedDBController.js